module.exports = __webpack_public_path__ + "img/classement_feu.f4533d37.png";